/**
 * Typed error classes thrown by the records API surface.
 * Catch with `instanceof` to drive user-facing messaging.
 */

export class ConflictError extends Error {
  constructor(public currentVersion: number, public currentStatus: string) {
    super('تعارض نسخه')
    this.name = 'ConflictError'
  }
}

export class DeleteForbiddenError extends Error {
  constructor(public action: 'delete' | 'restore') {
    super(
      action === 'delete'
        ? 'حذف این سابقه بر اساس تنظیمات پروژه مجاز نیست'
        : 'بازیابی سابقه فقط توسط مدیر پروژه امکان‌پذیر است'
    )
    this.name = 'DeleteForbiddenError'
  }
}

export class OpenDeclineCommentsError extends Error {
  constructor(public count: number) {
    super('نظرات رد باز وجود دارد')
    this.name = 'OpenDeclineCommentsError'
  }
}

export class RecordLockedError extends Error {
  constructor(public currentStatus: string) {
    super('این سابقه قابل ویرایش نیست')
    this.name = 'RecordLockedError'
  }
}

export class FormLockedError extends Error {
  constructor() {
    super('این فرم ارسال شده و در حالت فعلی قابل ویرایش نیست')
    this.name = 'FormLockedError'
  }
}

export class CommentResolutionForbiddenError extends Error {
  constructor(public reason: 'forbidden' | 'author_cannot_self_resolve' | 'deleted') {
    super(
      reason === 'author_cannot_self_resolve'
        ? 'نویسنده نمی‌تواند نظر رد خود را حل‌شده اعلام کند'
        : reason === 'deleted'
        ? 'این نظر حذف شده است'
        : 'دسترسی غیرمجاز برای حل نظر',
    )
    this.name = 'CommentResolutionForbiddenError'
  }
}
